import { NewIamHelper } from '../../shared/components/helpers';

(function () {
    'use strict';

    angular
        .module('employeeControllers')
        .controller('EmployeePositionInHierarchyController', Controller);

    Controller.$inject = ['$scope', '$state', 'employeeService', 'authenticatedUserService'];

    function Controller($scope, $state, employeeService, authenticatedUserService) {
        $scope.goToEmployeeProfile      = goToEmployeeProfile;
        $scope.goToNewRequest           = goToNewRequest;
        $scope.goToAccessCards          = goToAccessCards;
        $scope.showNewRequestAction     = showNewRequestAction;
        $scope.switchEmployee           = switchEmployee;

        authenticatedUserService
            .getAuthenticatedUser()
            .then(function (authenticatedUser) {
                $scope.authenticatedUser = authenticatedUser;
            });

        function goToEmployeeProfile(employeeID) {
            $scope.$hide();
            NewIamHelper.navigateTo('profile.employee', employeeID);
        }

        function goToNewRequest(employeeID) {
            $scope.$hide();
            $state.go('userAccessRequest.request.byEmployeeId', { employeeId: employeeID });
        }

        function goToAccessCards(employeeID) {
            $scope.$hide();
            $state.go('profile.employee.accessCards', { EmployeeID: employeeID });
        }

        function showNewRequestAction() {
            return $scope.authenticatedUser.IsInAdministrationGroup || $scope.authenticatedUser.IsInITOperationsGroup || $scope.authenticatedUser.IsInBTGAccessManagementGroup;
        }

        function switchEmployee(employeeID) {
            employeeService
                .getEmployeePositionInHierarchy(employeeID)
                .then(function (response) {
                    $scope.employee = response.data;
                });
        }
    }
})();
